import React, {useEffect, useState} from "react";
import GoogleMapReact from 'google-map-react';


const defaultProps = {
    center: {
        lat: 35.6892,
        lng: 51.3890
    },
    zoom: 11
};

const AnyReactComponent = ({ text }) => {
    return(
        <div style={{backgroundColor:"red",margin:0,padding:0}}>
            <img style={{width:50}} src={"https://cdn0.iconfinder.com/data/icons/small-n-flat/24/678111-map-marker-512.png"} alt=""/>
        </div>
    )
};




function Map({coordinate}) {

    const [lat,set_lat] = useState(coordinate.lat)
    const [lng,set_lng] = useState(coordinate.lng)
    const [center,set_center] = useState( {lat: 35.6892, lng: 51.3890})
    const [change,set_change] = useState({})


    const changeMap = (e) =>{
        set_change(e)
    }

    useEffect(()=>{
        set_lat(coordinate.lat)
        set_lng(coordinate.lng)
        set_center(coordinate)
    },[coordinate])


    return(
        <div style={{ height: '100vh' ,width:"100%" ,display:"flex",justifyContent:"center"}}>
            <GoogleMapReact
                bootstrapURLKeys={{ key: "AIzaSyCOEa8Z87h6TIuiCyzoPGj6bKskRFTZat0" }}
                defaultCenter={center}
                defaultZoom={defaultProps.zoom}
                onChange={changeMap}
                options={{
                    gestureHandling: "greedy",
                    styles: [
                        { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
                        { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
                        { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
                        {
                            featureType: "administrative.locality",
                            elementType: "labels.text.fill",
                            stylers: [{ color: "#d59563" }]
                        },
                        {
                            featureType: "poi",
                            elementType: "labels.text.fill",
                            stylers: [{ color: "#d59563" }]
                        },
                        {
                            featureType: "poi.park",
                            elementType: "geometry",
                            stylers: [{ color: "#263c3f" }]
                        },
                        {
                            featureType: "poi.park",
                            elementType: "labels.text.fill",
                            stylers: [{ color: "#6b9a76" }]
                        },
                        {
                            featureType: "road",
                            elementType: "geometry",
                            stylers: [{ color: "#38414e" }]
                        },
                        {
                            featureType: "road",
                            elementType: "geometry.stroke",
                            stylers: [{ color: "#212a37" }]
                        },
                        {
                            featureType: "road",
                            elementType: "labels.text.fill",
                            stylers: [{ color: "#9ca5b3" }]
                        },
                        {
                            featureType: "road.highway",
                            elementType: "geometry",
                            stylers: [{ color: "#746855" }]
                        },
                        {
                            featureType: "road.highway",
                            elementType: "geometry.stroke",
                            stylers: [{ color: "#1f2835" }]
                        },
                        {
                            featureType: "road.highway",
                            elementType: "labels.text.fill",
                            stylers: [{ color: "#f3d19c" }]
                        },
                        {
                            featureType: "transit",
                            elementType: "geometry",
                            stylers: [{ color: "#2f3948" }]
                        },
                        {
                            featureType: "transit.station",
                            elementType: "labels.text.fill",
                            stylers: [{ color: "#d59563" }]
                        },
                        {
                            featureType: "water",
                            elementType: "geometry",
                            stylers: [{ color: "#17263c" }]
                        },
                        {
                            featureType: "water",
                            elementType: "labels.text.fill",
                            stylers: [{ color: "#515c6d" }]
                        },
                        {
                            featureType: "water",
                            elementType: "labels.text.stroke",
                            stylers: [{ color: "#17263c" }]
                        }
                    ]
                }}
            >
                <AnyReactComponent lat={lat} lng={lng} text="آدرس من"/>
            </GoogleMapReact>
        </div>
    )
}

export {Map};
